// PRODUCTION VARIABLES

export const environment = {
  production: true,
  env: 'prod',
  API_BASE_URL: 'https://ss-coreapi-pro.herokuapp.com/api',
  NODE_DRAFTER_URL: 'https://node-drafter-pro.herokuapp.com', // drafter
  URL_TEAM_IMAGES: 'https://s3.us-east-2.amazonaws.com/',
  URL_PRODUCT_IMAGES: 'https://s3-us-west-1.amazonaws.com/ss-product-images/',
  URL_THUMB_IMAGES: 'https://s3-us-west-1.amazonaws.com/thumb-imgs-prod/', // For profile pics
  STRIPE_CLIENT_KEY: 'ca_DYYA7SNPvbd8MZG2tZY1aQjEPiuVCxRe',
  STRIPE_CONNECT_URL: 'https://connect.stripe.com/oauth/token',
  ZENDESK_DOMAIN: 'seasonshare.zendesk.com',
  FACEBOOK_ID: '650486651802196',
  HEADER_TEXT: "Split and Share Season Tickets",

  IS_WHITE_LABEL: false, 
  WHITE_LABEL_TEAM_ID: 180,
  BADGE_LOGO_URL:"/assets/images/logos/badge-blue.png"
  // kraken BADGE_LOGO_URL:"/assets/images/logos/kraken/dark.png"
};


// WEBPACK FOOTER //
// ./src/environments/environment.ts